// src/activeLocale.ts
import { enUS, ar } from "date-fns/locale";
var LOCALE_TABLE = {
  en: { dateFns: enUS, bcp47: "en-US" },
  ar: { dateFns: ar, bcp47: "ar" }
};
var LANG_KEY = "__maatActiveDateLang";
var g = globalThis;
var activeEntry = () => LOCALE_TABLE[g[LANG_KEY] ?? "en"] ?? LOCALE_TABLE.en;
var setActiveDateLocale = (lang) => {
  g[LANG_KEY] = LOCALE_TABLE[lang] ? lang : "en";
};
var getDateFnsLocale = () => activeEntry().dateFns;
var getActiveDateLocaleTag = () => activeEntry().bcp47;

export {
  setActiveDateLocale,
  getDateFnsLocale,
  getActiveDateLocaleTag
};
